import { useContext } from "react";
import { SessionContext } from '../../Components/Context/SessionContext';
import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import { Redirect } from 'react-router-dom'
import { useQuery } from 'react-query';
import * as Api from '../../api/Api';
import * as KeyNames from '../../api/KeyNames';
import { ErrorConnection } from '../../Components/Error/Error';
import { Loading } from '../../Components/Loading/Loading';
import { FeedbackContext } from "../../Components/Context/FeedbackContext";
import './authentication.css';

export function Login() {
    localStorage.clear(KeyNames.PathName);

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const { setSession } = useContext(SessionContext);

    const [loginData, setLoginData] = useState(null);
    const [rememberMe, setRememberMe] = useState(true);

    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const onSubmit = data => setLoginData(data);

    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionData, (loginData && loginData)],
        async () => await Api.getLogin(loginData),
        {
            enabled: Boolean(loginData)
        });

    useEffect(() => {

        if (data) {
            if (data.success) {
                sessionStorage.setItem(KeyNames.SessionData, data?.data?.sessionToken);
                sessionStorage.setItem(KeyNames.SessionData + " email", data.data.email);
                window.location.reload()
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }
    }, [data]);

    useEffect(() => {
        if (loginData) {
            setValue('email', '');
            setValue('password', '');
        }
    }, [loginData]);


    if (isLoading) return (<Loading />)

    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    if (data?.data)
        return (
            <Redirect to='/' />
        )

    return (
        <form onSubmit={handleSubmit(onSubmit)}
            className='form w-100'
            id='kt_login_signin_form'
        >
            <div className='text-center mb-10'>
                <h1 className='text-dark mb-3'>Iniciar Sesión</h1>

            </div>
            <div className='fv-row mb-10'>
                <label className='form-label fs-6 fw-bolder text-dark'>Correo Electrónico</label>
                <input {...register("email", { required: true })}
                    placeholder=''
                    className=
                    'form-control form-control-lg form-control-solid'
                    type='text'
                    name='email'
                    autoComplete='off'
                />
                <>{errors.email && <span className="text-danger">Ingresar correo electrónico</span>}</>
            </div>
            <div className='fv-row mb-10'>
                <div className="d-flex flex-stack mb-2">
                    <label className='form-label fs-6 fw-bolder text-dark'>Contraseña</label>
                    <a
                        href='/auth/forgotPassword'
                        className='link-primary fs-6 fw-bolder'

                    >
                        ¿Olvidaste tu contraseña?
                    </a>
                </div>
                <input {...register("password", { required: true })}

                    className=
                    'form-control form-control-lg form-control-solid'
                    type='password'
                    autoComplete='off'
                />
                <>{errors.password && <span className="text-danger">Ingresar Contraseña</span>}</>
            </div>
            <div className='text-center'>
                <button
                    type='submit'
                    id='kt_sign_in_submit'
                    className='btn btn-lg btn-primary w-100 mb-5'

                >
                    <span className='indicator-label'>Continuar</span>
                </button>

            </div>
            <div className="form-check form-check-custom form-check-solid form-check-inline mb-5">
                <input className="form-check-input" type="checkbox" checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)} />
                <span className="form-check-label fw-bold text-gray-700">Recordar mis datos</span>

            </div>
        </form>
    )
}
